import React from "react";

const Message = ({ type }) => {
    //pass in prop called type with a value of "saved, updated or deleted". This determines what message displays
    const messages = {
        saved: "Dish/Recipe has been saved.",
        updated: "Dish/Recipe has been updated.",
        deleted: "Dish/Recipe has been deleted."
    };
    return (

            <div className={`App-message container alert alert-dismissible fade show ${type}`} role="alert">
            
                <div className="d-flex justify-content-between align-items-center">
                    {
                        //message[type] pattern is how you can call an object property when the name of the property is a variable rather than something that can be hard coded
                    }
                    <span>{messages[type]}</span>
                    <button type="button" className="close btn--close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                    </span>
                    </button>
                </div>
                
            </div>

    );
};

export default Message;